
export const SUPPORTED_BROWSERS = {
    CHROME: 'chrome',
    EDGE: 'edge',
    FIREFOX: 'firefox',
    SAFARI: 'safari',
    SAMSUNG_INTERNET: 'samsung_internet',
    BRAVE: 'brave',
    OTHER: 'other',
};

export const detectBrowser = (userAgentValue) => {
    const hasNavigator = typeof navigator !== 'undefined';
    const userAgent =
        (userAgentValue ||
            (hasNavigator ? navigator.userAgent : '') ||
            '')
            .toLowerCase();

    const brands = hasNavigator && navigator.userAgentData?.brands
        ? navigator.userAgentData.brands
        : [];
    const isBraveByUserAgentData = brands.some((brandItem) =>
        String(brandItem?.brand || '').toLowerCase().includes('brave')
    );
    const isBraveByNavigatorApi = hasNavigator && typeof navigator.brave !== 'undefined';

    if (!userAgent) {
        return {
            id: SUPPORTED_BROWSERS.OTHER,
            name: 'Navegador desconocido',
        };
    }

    if (userAgent.includes('samsungbrowser')) {
        return {
            id: SUPPORTED_BROWSERS.SAMSUNG_INTERNET,
            name: 'Samsung Internet',
        };
    }

    if (userAgent.includes('edg/')) {
        return {
            id: SUPPORTED_BROWSERS.EDGE,
            name: 'Microsoft Edge',
        };
    }

    if (userAgent.includes('firefox/') || userAgent.includes('fxios/')) {
        return {
            id: SUPPORTED_BROWSERS.FIREFOX,
            name: 'Mozilla Firefox',
        };
    }
    if (
        userAgent.includes('brave/') ||
        isBraveByUserAgentData ||
        isBraveByNavigatorApi
    ) {
        return {
            id: SUPPORTED_BROWSERS.BRAVE,
            name: 'Brave',
        };
    }

    if (
        (userAgent.includes('chrome/') || userAgent.includes('crios/')) &&
        !userAgent.includes('edg/') &&
        !userAgent.includes('opr/') &&
        !userAgent.includes('samsungbrowser') &&
        !userAgent.includes('brave/')
    ) {
        return {
            id: SUPPORTED_BROWSERS.CHROME,
            name: 'Google Chrome',
        };
    }

    if (
        (userAgent.includes('safari/') || userAgent.includes('version/')) &&
        !userAgent.includes('chrome/') &&
        !userAgent.includes('crios/') &&
        !userAgent.includes('android')
    ) {
        return {
            id: SUPPORTED_BROWSERS.SAFARI,
            name: 'Safari',
        };
    }

    return {
        id: SUPPORTED_BROWSERS.OTHER,
        name: 'Navegador no identificado',
    };
};
